import {Button, Skeleton, Stack} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {DotsContainer, StyledDotButton} from '../Banners/styles';

const {next, prev} = translations['pt-br'].commons;

export function BannersLoading() {
	const {isMobile} = useMediaQueries();

	return (
		<Stack>
			<Skeleton sx={{transform: 'initial'}} height={220} />
			{!isMobile ? (
				<DotsContainer>
					<Button
						disabled
						sx={{mr: 'auto', lineHeight: 0}}
						variant="text"
						size="small"
						startIcon={<Icon name="arrow-left-filled" size={18} />}>
						{prev}
					</Button>
					{Array.from(Array(3)).map((_, index) => (
						<StyledDotButton key={index} />
					))}
					<Button
						disabled
						sx={{ml: 'auto', lineHeight: 0}}
						variant="text"
						size="small"
						endIcon={<Icon name="arrow-right-filled" size={18} />}>
						{next}
					</Button>
				</DotsContainer>
			) : null}
		</Stack>
	);
}
